import { useCreditsSync } from '@/features/credits';
import useCreditsSubscription from '@/hooks/useCreditsSubscription';

/**
 * Session-level state syncs: SDK credits subscription and the logout-clear
 * effect. User auth is established at bootstrap (entry.tsx → startAuthSync),
 * so this hook just wires reactive sync.
 */
const useSessionBootstrap = () => {
  useCreditsSubscription();
  useCreditsSync();
};

export default useSessionBootstrap;
